import "./About.css";
import AboutHero from "./AboutHero";
import OurTeam from "./OurTeam";
import SolveProblem from "./SolveProblem";

export default function AboutUs() {
  return (
    <>
      <AboutHero />
      <OurTeam />
      <SolveProblem />
    </>
  );
}
